module.exports = __webpack_public_path__ + "img/ic_duration.8a7dfe0d.png";